/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyTypeModel } from '../../models/client-survey-type-model';
import { CreateSurveyTypeRequest } from '../../models/create-survey-type-request';

export interface CreateSurveyType$Json$Params {
  
    /**
     * properties of surveytype to create
     */
    body?: CreateSurveyTypeRequest
}

export function createSurveyType$Json(http: HttpClient, rootUrl: string, params?: CreateSurveyType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyType$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyTypeModel>;
    })
  );
}

createSurveyType$Json.PATH = '/api/SurveyType';
